<template>
  <div class="spinner spinner-1" :style="{ color: this.color }"></div>
</template>

<script>
export default {
  name: 'spinner',
  props: ['color'],
  defineProps: {
    color: '#0d76ff',
  },
};
</script>

<style src="./Spinner.scss" lang="scss"></style>
